import { OpenableCard, FAQ } from '@hg/stylizator/components'
import { Text } from '@hg/stylizator/typography'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes extends React.ComponentProps<typeof FAQ> {
  questions?: { title: string; body: string }[]
}

interface ICardProps extends Pick<IAttributes, 'background'> {
  title: React.ReactNode
  defaultOpened?: boolean
  disabled?: boolean
}

const FAQBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity:
      attributes?.questions?.map((question) => ({
        '@type': 'Question',
        name: question.title,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.body,
        },
      })) ?? [],
  }

  return (
    <FAQ
      title={attributes.title}
      background={attributes.background}
      disclaimer={typeof attributes.disclaimer === 'string' ? parse(attributes.disclaimer) : attributes.disclaimer}
    >
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      {attributes.questions?.map((question, index) => (
        <Card key={index} title={question.title} background={attributes.background}>
          <Text type="body" useCompact>
            <p>{parse(question.body ?? '')}</p>
          </Text>
        </Card>
      ))}
    </FAQ>
  )
}

export default FAQBlock

export const Card: React.FC<React.PropsWithChildren<ICardProps>> = (props) => {
  const [isOpened, setOpened] = React.useState(props.defaultOpened ?? false)
  const cardBackground = props.background === 'dark' || props.background === 'blue' ? 'blue' : 'white'

  return (
    <OpenableCard
      opened={isOpened}
      onToggle={props.disabled ? () => {} : () => setOpened((v) => !v)}
      title={props.title}
      background={cardBackground}
    >
      {props.children}
    </OpenableCard>
  )
}
